export enum PolciyTypeEnum {
    OBAMACARE = 1,
    MEDICARE,
    FINAL_EXPENSE,
    WHOLE_LIFE,
    TERM_LIFE
}